import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Instagram, Mail, Shield, Lock, CreditCard } from 'lucide-react';

const Footer = ({ isAuthenticated = false, isProPlan = false }) => {
  const logoDestination = isAuthenticated ? '/dashboard' : '/';

  return (
    <footer className="bg-gray-900 text-gray-400 py-16 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-4 gap-12">
          <div>
            <Link to={logoDestination} className="flex items-center space-x-2 mb-4 hover:opacity-80 transition-opacity">
              <Sparkles className="w-6 h-6 text-rose-400" />
              <span className="text-xl font-bold text-white">VirtualFit</span>
            </Link>
            <p className="text-sm mb-4">AI-powered virtual try-on platform for brands, influencers, and shoppers.</p>
            <div className="space-y-2">
              <a 
                href="https://www.instagram.com/virtualfitwork/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-gray-400 hover:text-rose-400 transition-colors"
              >
                <Instagram className="w-5 h-5" />
                <span className="text-sm">@virtualfitwork</span>
              </a>
              <a 
                href="mailto:hello@virtualfit.work"
                className="flex items-center space-x-2 text-gray-400 hover:text-rose-400 transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span className="text-sm">hello@virtualfit.work</span>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-2 text-sm">
              {!isAuthenticated && (
                <li><Link to="/subscribe" className="hover:text-white">Pricing</Link></li>
              )}
              <li><Link to="/search" className="hover:text-white">Discover Brands & Influencers</Link></li>
              <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
              {isAuthenticated && (
                <li><Link to="/dashboard" className="hover:text-white">Dashboard</Link></li>
              )}
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
              <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
              <li><Link to="/biometric-policy" className="hover:text-white">Biometric Data Policy</Link></li>
              <li><Link to="/refund-policy" className="hover:text-white">Refund & Cancellation</Link></li>
              <li><Link to="/acceptable-use" className="hover:text-white">Acceptable Use</Link></li>
            </ul>
          </div>
        </div>
        
        {/* Trust Badges */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-6 mb-6">
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <CreditCard className="w-4 h-4 text-gray-500" />
              <span>Secured by Stripe</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <Lock className="w-4 h-4 text-gray-500" />
              <span>256-bit SSL Encrypted</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <Shield className="w-4 h-4 text-gray-500" />
              <span>GDPR Compliant</span>
            </div>
          </div>
          <p className="text-center text-sm">&copy; {new Date().getFullYear()} VirtualFit. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
